// extracted by mini-css-extract-plugin
var _1 = "sectioned-icon__Ept9j";
export { _1 as "sectionedIcon" }
